import { axiosInstance, tokenConfig } from '../axiosInstance';
import { GET_SERVICE_ITEM_SUCCESS, GET_SERVICE_ITEM_FAIL, SERVICE_ITEM_LOADING } from './types.js';
import { returnErrors, clearErrors } from '../actions/errorActions';


export const getfreelancerServiceItem = ({ id, locale }) => {
    return async function(dispatch, getState){
        dispatch(clearErrors());
        dispatch({
            type: SERVICE_ITEM_LOADING
        });
        try {
            let response = await axiosInstance.get(`/api/services?id=${id}`, tokenConfig(getState, locale));
            if(response.status !== 200){
                dispatch({
                    type: GET_SERVICE_ITEM_FAIL,
                });
                throw Error({
                    response: {
                        data: "Other Errors",
                        status: "Other Errors"
                    },
                })
            }else{
                dispatch({
                    type: GET_SERVICE_ITEM_SUCCESS,
                    payload: response.data
                })
            }
        } catch (error) {
            if (error.response && error.response.data) {
                dispatch(returnErrors(error.response.data, error.response.status, 'GET_SERVICE_ITEM_FAIL'));
                dispatch ({ 
                    type: GET_SERVICE_ITEM_FAIL 
                });
            }else{
                let errorJson = JSON.stringify(error);
                let errorParsed = JSON.parse(errorJson);
                return (
                    dispatch(returnErrors(errorParsed.message, "Network Error", 'GET_SERVICE_ITEM_FAIL')),
                    dispatch ({ 
                        type: GET_SERVICE_ITEM_FAIL 
                    })
                )
            }
        }
    }
};

const exportedObject = {
    getfreelancerServiceItem
};

export default exportedObject;